// Section8.jsx - Simple & Clean (No ESLint Error)
import React from 'react';

const Section8 = () => {
  const benefits = [
    "Increase user engagement",
    "Improve work efficiency",
    "Automate business workflows",
    "Strengthen customer loyalty",
    "Generate new revenue streams",
    "Enhance user experiences",
    "Scale digital products effectively"
  ];

  return (
    <section id="benefits" className="bg-white py-[20px] md:py-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">Business Impact</span>
            <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3 mb-5">
              Business Benefits
            </h2>
            <p className="text-[#535353] text-[16px]">
              Our mobile application development service helps organizations:
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center gap-4 bg-[#fafafa] hover:bg-[#cd2122]/5 border border-transparent hover:border-[#cd2122]/20 p-6 rounded-2xl transition-all duration-300 hover:shadow-md group"
              >
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#cd2122] text-white font-bold text-base flex items-center justify-center group-hover:scale-110 transition-transform">
                  ✓
                </span>
                <p className="text-[#535353] text-[16px] leading-relaxed">{benefit}</p>
              </div>
            ))}
          </div>

          <p className="text-[#535353] text-[16px] mt-12 text-center italic">
            We mix smart planning with tech skills. This helps us make mobile apps that bring long-term business value.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Section8;